var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-row",
    [
      _c(
        "v-col",
        { attrs: { sm: _vm.marketOnly ? 12 : 6 } },
        [
          _c("v-select", {
            attrs: {
              dense: _vm.dense,
              items: _vm.availableMarkets,
              label: "Market",
              rules: [
                function (v) {
                  return !!v || "required"
                },
              ],
            },
            on: {
              change: function ($event) {
                return _vm.$emit("change")
              },
            },
            model: {
              value: _vm.computedValue.name,
              callback: function ($$v) {
                _vm.$set(_vm.computedValue, "name", $$v)
              },
              expression: "computedValue.name",
            },
          }),
        ],
        1
      ),
      !_vm.marketOnly
        ? [
            _c(
              "v-col",
              { attrs: { sm: "6" } },
              [
                _c("v-select", {
                  attrs: {
                    disabled: !_vm.computedValue.name,
                    dense: _vm.dense,
                    items: _vm.allowedIndexes,
                    label: "Index Type",
                    "item-text": "text",
                    rules: [
                      function (v) {
                        return !!v || "required"
                      },
                    ],
                  },
                  on: {
                    change: function ($event) {
                      return _vm.$emit("change")
                    },
                  },
                  model: {
                    value: _vm.computedValue.index,
                    callback: function ($$v) {
                      _vm.$set(_vm.computedValue, "index", $$v)
                    },
                    expression: "computedValue.index",
                  },
                }),
              ],
              1
            ),
            _c(
              "v-col",
              { attrs: { sm: "12" } },
              [
                _vm.showNodeData
                  ? _c("InputMarketNode", {
                      key: "node-dd-" + _vm.nodeDropdownKey,
                      attrs: {
                        dense: _vm.dense,
                        market: _vm.value.name,
                        "index-type": _vm.value.index,
                      },
                      on: {
                        change: function ($event) {
                          return _vm.$emit("change")
                        },
                      },
                      model: {
                        value: _vm.computedMarketNode,
                        callback: function ($$v) {
                          _vm.computedMarketNode = $$v
                        },
                        expression: "computedMarketNode",
                      },
                    })
                  : _vm._e(),
                _vm.showNodeData && _vm.nodeAvailabilityLabel
                  ? _c("div", { staticClass: "text-caption grey--text pl-1" }, [
                      _vm._v(
                        " Data availability: " +
                          _vm._s(_vm.nodeAvailabilityLabel) +
                          " "
                      ),
                    ])
                  : _vm._e(),
              ],
              1
            ),
          ]
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }